import { apiSlice } from "./apiSlice";

export const artistApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getArtist: builder.query({
            query: ({id}) => ({
                url: `/artists/${id}`,
                method: 'GET',
            }),
            providesTags: (_artist, _err, _id) => [{type: 'Artist', _id}],
        }),
        getArtists: builder.query({
            query: (ids) => ({
                url: `/v1/artists/multiple/${ids}`,
                method: 'GET'
            }),
            providesTags: ['Artist']
        }),
        getArtistTracks: builder.query({
            query:  ({id}) => ({
                url: `/v1/artists/${id}/tracks`,
                method: 'GET'
            })
        }),
        getArtistCollabs: builder.query({
            query: ({id}) => ({
                url: `/v1/artists/${id}/collabs`,
                method: 'GET'
            }),
            providesTags: (result, error, arg) => [
                ...result.map((collab, i) => ({ type: 'Artist', id: collab.artist._id }))
            ]  
        })
    })
})

export const {
    useGetArtistQuery,
    useGetArtistTracksQuery,
    useGetArtistCollabsQuery,
    useGetArtistsQuery
} = artistApiSlice